import { getString } from "@/common/uistringlabels/ui-string-utils";

export const REQUIRED_FIELD_ERROR = getString("checkout.formPanel.requiredFieldError");

export const validateRequiredString = (value: string) =>
  value.trim() !== "" || REQUIRED_FIELD_ERROR;
